import { useCallback, useState } from "react";
import { resetUserPassword as resetUserPassword } from "../network";

export const useResetUserPassword = (): [
  boolean | null,
  boolean,
  Error | null,
  (userId: string) => Promise<void>,
  () => void
] => {
  const [result, setResult] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (userId: string) => {
    setIsLoading(true);
    setResult(false);
    setError(null);

    try {
      await resetUserPassword(userId);
      setResult(true);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return [result, isLoading, error, request, clearError];
};
